import { render } from "./PaginateComponent.vue?vue&type=template&id=0fef3bcb&scoped=true"
import script from "./PaginateComponent.vue?vue&type=script&lang=js"
export * from "./PaginateComponent.vue?vue&type=script&lang=js"

import "./PaginateComponent.vue?vue&type=style&index=0&id=0fef3bcb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fef3bcb"]])

export default __exports__